import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {inject} from '@angular/core';
import {AccountingClient} from 'src/app/core/services/service-clients';
import {firstValueFrom} from 'rxjs';
import {AccountingState} from './models/accounting.model';

const initialState: AccountingState = {
  accountingGroups: null,
  loading: false,
  annualReport: null,
  annualReportLoading: false,
};

export const accountingStore = signalStore(
  withState<AccountingState>(initialState),

  withMethods((store) => {
    const accountingClient = inject(AccountingClient);

    return {
      async getAccounting(): Promise<boolean> {
        patchState(store, {loading: true});
        try {
          const accountingGroup = await firstValueFrom(accountingClient.getAccounting());
          patchState(store, {
            accountingGroups: [accountingGroup],
            loading: false
          });
          return true;
        } catch {
          patchState(store, {loading: false});
          return false;
        }
      },

      async getAccountingByDateRange(startDate: Date, endDate: Date): Promise<boolean> {
        patchState(store, {loading: true});
        try {
          const accountingGroups = await firstValueFrom(
            accountingClient.getAccountingByDate(startDate, endDate)
          );
          patchState(store, {
            accountingGroups,
            loading: false
          });
          return true;
        } catch {
          patchState(store, {loading: false});
          return false;
        }
      },

      async getAnnualReport(year: number): Promise<boolean> {
        patchState(store, {annualReportLoading: true});
        try {
          const annualReport = await firstValueFrom(
            accountingClient.getAnnualReport(year)
          );
          patchState(store, {
            annualReport,
            annualReportLoading: false
          });
          return true;
        } catch {
          patchState(store, {annualReportLoading: false});
          return false;
        }
      }
    };
  })
);
